import React from "react";
import {
  Grommet,
  Box,
  Button,
  Form,
  FormField,
  Text,
  TextInput,
  MaskedInput,
  CheckBox,
  Spinner,
} from "grommet";
import { Hide, View } from "grommet-icons";
import * as axios from "axios";
import "../App.css";

class FormRegister extends React.Component {
  constructor(props) {
    super(props);
    //"http://127.0.0.1/webwassermaticvendinginnovation/index.php/apiViews/getListaBanners",
    this.state = {
      vistaActual: 0, //0 no muestra  , 1 youtube detalles
      dataLista: [],
      currentFormURL: "https://matixds.com:4530/users/login",
      urlValidate: "https://matixds.com:4530/webviewsapi/validateMovil",
      urlRegister: "https://matixds.com:4530/webviewsapi/singUpUser", //3045 es la url de mantenimiento
      T_NOMBRE: "",
      cssT_NOMBRE: "divTxtSmall2x",
      T_EMAIL: "",
      T_TELEFONO_MOVIL: "",
      cssT_MOVIL: "divTxtSmall2x",
      T_PASSWORD: "",
      cssT_PASS: "divTxtSmall2x",
      T_PASSWORD_CONFIRMAR: "",
      cssT_PASSCONFIRM: "divTxtSmall2x",
      FormListo: false,
      FormErrors: "",
      checkTerminos: true,
      revealPass1: false,
      revealPass2: false,
      cssError: "", //representa la puesta deuna clase
      btLoading: 0,
      msgeCompletado: "", //mensaje de registro completado
      txtErrorAcceso: "",
    };
    this.inputLoginDS = React.createRef();
    //bind de los eventois click
    /*
    this.fnClickAddProducto = this.fnClickAddProducto.bind(this);
    this.fnCambio = this.fnCambio.bind(this);
    this.fnCambioBack = this.fnCambioBack.bind(this);
    this.fnVerVideo = this.fnVerVideo.bind(this);

    this.fnCerrarVideo = this.fnCerrarVideo.bind(this);
    */
  }

  fnClickAddProducto() {
    // alert("Clicked Button");
    this.setState({ vistaActual: 1 });
  }

  componentDidMount() {
    //this.fnLista();
    //  alert("hola");
    // setInterval(() => {
    //   console.log('Interval triggered');
    // }, 1000);
  }
  fnvalidateMovil() {
    axios
      .request({
        method: "post",
        url: this.state.urlValidate,
        data: {
          movil: this.state.T_TELEFONO_MOVIL.replace(" ", "")
            .replace("(", "")
            .replace(")", "")
            .replace("-", "")
            .replace("-", ""),
        },
        onUploadProgress: (p) => {},
      })
      .then(
        (response) => {
          //alert("FUNC::" +response.data.res);
          if (response.data.res == "SI") {
                this.setState({ btLoading: 1 });
                this.fnInsertarRegistro();
            return 1;
          } else {
            this.setState({txtErrorAcceso:"El teléfono que escribió ya tiene una cuenta, por favor, verifique el número"});
            this.setState({ cssT_ACCESO: "divError" });
            return 0;
          }
        },
        (error) => {
          this.setState({ btLoading: 0 });
          this.setState({ msgeCompletado: error });
          console.log(error);
          return 0;
        }
      );
  }

  async fnLista() {
    // alert(this.state.urlLista);
    //obtiene sucursales para variable global
    fetch(this.state.urlLista, {
      headers: { "Cache-Control": "no-cache" },
    })
      .then((response) => response.json())
      .then((json) => {
        //alert(json[0].E_ORDEN)
        //  var resultado=JSON.stringify(json);
        // alert(resultado);
        this.setState({ numeroTotal: json.length });
        this.setState({ dataLista: json });
        this.setState({ vistaCarousel: 1 });
        for (var xx = 0; xx <= this.state.dataLista.length - 1; xx++) {
          //  var archivoThumb = fondoBase;
          //if (this.state.dataLista[xx].T_URL_ARCHIVO.length > 3) {
          //  archivoThumb =
          //    this.state.urlRepositorio +
          //    this.state.dataLista[xx].T_URL_ARCHIVO;
          //}
        }
        //alert(this.state.dataLista[3].T_TITULO);
        //   this.setState({
        //     urlArchivoActual: this.state.urlRepositorio + json[0].T_URL_ARCHIVO,
        //   });
        // alert(this.state.urlArchivoActual);
        //  this.fnCambio();

        // alert(JSON.stringify(json));
      })
      .catch((error) => alert(error))
      .finally(() => {
        // alert(JSON.stringify(this.state.dataSucursales));
        // this.setState({ isLoading: false });
      });
  }

  fnValidarFormulario() {
    // this.setState({FormErrors:""});

    var frmListo = 1;
    var cadenaErrores = "";
    this.setState({ cssT_NOMBRE: "" });
    this.setState({ cssT_MOVIL: "" });
    this.setState({ cssT_PASS: "" });
    this.setState({ cssT_PASSCONFIRM: "" });

    if (this.state.T_NOMBRE.length < 3) {
      //cadenaErrores = cadenaErrores + "\n" + " / Escriba su nombre completo";
      this.setState({ cssT_NOMBRE: "txtError" });

      frmListo = 0;
      //this.nameInput.focus();
    }
    if (this.state.T_TELEFONO_MOVIL.length < 10) {
      // cadenaErrores = cadenaErrores + " Escriba un telefono correcto";
      this.setState({ cssT_MOVIL: "txtError" });
      frmListo = 0;
    }
    if (this.state.T_PASSWORD.length == 0) {
      cadenaErrores = cadenaErrores + " Escriba una contraseña";
      this.setState({ cssT_PASS: "txtError" });
      frmListo = 0;
    }
    if (this.state.T_PASSWORD != this.state.T_PASSWORD_CONFIRMAR) {
      cadenaErrores = cadenaErrores + "  Las contraseñas no coinciden";
      this.setState({ cssT_PASSCONFIRM: "txtError" });
      frmListo = 0;
    }
    if (frmListo == 0) {
      this.setState({ txtErrorAcceso: cadenaErrores });
      this.setState({ cssT_ACCESO: "divError" });

      //   this.setState({
      //     FormErrors: cadenaErrores,
      //   });
    }
    return frmListo;
  }
  fnInsertarRegistro() {
    axios
      .request({
        method: "post",
        url: this.state.urlRegister,
        data: {
          T_NOMBRE: this.state.T_NOMBRE,
          T_TELEFONO_MOVIL: this.state.T_TELEFONO_MOVIL.replace(" ", "")
            .replace("(", "")
            .replace(")", "")
            .replace("-", "")
            .replace("-", ""),
          T_PASSWORD: this.state.T_PASSWORD,
        },
        onUploadProgress: (p) => {
          console.log("Registrando usuario " + p);
          //this.setState({captura01Porcentaje:p.loaded / p.total})
          //this.setState({
          //fileprogress: p.loaded / p.total
          //})
        },
      })
      .then(
        (response) => {
          //JSON.stringify(response)
          this.setState({
            msgeCompletado: "Registro completado, Bienvenido a matixDS!",
          });
          this.setState({ btLoading: 1 });
          setTimeout(() => {
       
            this.inputLoginDS.current.click();
            
        }, 3000);
         
          //regresa a su componente parent
          // this.props.parentReference(
          //   this.state.T_TELEFONO_MOVIL + "/" + this.state.T_PASSWORD
          // );

          // RESULTADO DE ENVIO AL COMPONENTE PARENT
        },
        (error) => {
          this.setState({ btLoading: 0 });
          this.setState({ msgeCompletado: error });
          console.log(error);
        }
      );
  }

  render() {
    let contenidos = <div></div>;
    let conBtAcces = (
      <div>
        <br />
        <Button
          label="Crear Cuenta"
          primary
          onClick={() => {
            // alert("Creando Cuenta");

            var resValida = this.fnValidarFormulario();
           // alert("V1:" + resValida);
            if (resValida == 1) {
              var resValidaMovil = this.fnvalidateMovil();              
            }

            // this.props.parentReference(
            //  this.state.T_TELEFONO_MOVIL + "/" + this.state.T_PASSWORD
            // );
          }}
        />
        <br />
      </div>
    );

    let conBtspin = (
      <div align="center">
        <Spinner />
      </div>
    );
    let contBTAcceder = <div></div>;

    if (this.state.btLoading == 1) {
      contBTAcceder = conBtspin;
    } else {
      contBTAcceder = conBtAcces;
    }

    return (
      <Grommet>
        <Box align="center" background="graph-2" pad="medium">        
          Crear cuenta matixDS
        </Box>
        <div className={this.state.cssError}>{this.state.FormErrors}</div>
        <center>
          <div className="divRound">
            <div className={this.state.cssT_NOMBRE}>Nombre completo</div>
            <TextInput
              ref="nameInput"
              placeholder="Nombre completo"
              textAlign={"center"}
              value={this.state.T_NOMBRE}
              onChange={(e) => this.setState({ T_NOMBRE: e.target.value })}
            />
            <div className={this.state.cssT_MOVIL}>Teléfono móvil</div>
            <MaskedInput
              textAlign={"center"}
              mask={[
                { fixed: "(" },
                {
                  length: 3,
                  regexp: /^[0-9]{1,3}$/,
                  placeholder: "xxx",
                },
                { fixed: ")" },
                { fixed: " " },
                {
                  length: 3,
                  regexp: /^[0-9]{1,3}$/,
                  placeholder: "xxx",
                },
                { fixed: "-" },
                {
                  length: 4,
                  regexp: /^[0-9]{1,4}$/,
                  placeholder: "xxxx",
                },
              ]}
              value={this.state.T_TELEFONO_MOVIL}
              onChange={(e) =>
                this.setState({ T_TELEFONO_MOVIL: e.target.value })
              }
            />
            <div className={this.state.cssT_PASS}>
              Contraseña{" "}
              <Button
                icon={
                  this.state.revealPass1 ? (
                    <View size="medium" />
                  ) : (
                    <Hide size="medium" />
                  )
                }
                onClick={() =>
                  this.setState({ revealPass1: !this.state.revealPass1 })
                }
              />
            </div>
            <div>
              <TextInput
                textAlign={"center"}
                placeholder="Contraseña"
                type={this.state.revealPass1 ? "text" : "password"}
                value={this.state.T_PASSWORD}
                onChange={(event) =>
                  this.setState({ T_PASSWORD: event.target.value })
                }
              />
              <div className={this.state.cssT_PASSCONFIRM}>
                Confirmar contraseña
                <Button
                  icon={
                    this.state.revealPass2 ? (
                      <View size="medium" />
                    ) : (
                      <Hide size="medium" />
                    )
                  }
                  onClick={() =>
                    this.setState({ revealPass2: !this.state.revealPass2 })
                  }
                />
              </div>

              <TextInput
                textAlign={"center"}
                placeholder="Confirmar contraseña"
                type={this.state.revealPass2 ? "text" : "password"}
                value={this.state.T_PASSWORD_CONFIRMAR}
                onChange={(event) =>
                  this.setState({ T_PASSWORD_CONFIRMAR: event.target.value })
                }
              />
            </div>

            {contBTAcceder}
            {this.state.msgeCompletado}
            <div className={this.state.cssT_ACCESO}>
              {this.state.txtErrorAcceso}
            </div>

            <br />
            <div className="divTxtSmall">
              Al crear su cuenta en este sitio, usted esta de acuerdo <br />
              con nuestras{" "}
              <a
                href="https://matixds.com/index.php/home/politicasPrivacidad"
                target={"_blank"}
              >
                Políticas de privacidad
              </a>{" "}
              y{" "}
              <a
                href="https://matixds.com/index.php/home/terminosServicio"
                target={"_blank"}
              >
                Términos del servicio
              </a>
              <CheckBox
                checked={this.state.checkTerminos}
                label="Acepto"
                onChange={(event) => {
                  this.setState({ checkTerminos: !this.state.checkTerminos });
                }}
              />
            </div>

            <br />
            <div className="divTxtSmall2x">
              Ya eres miembro?
              <a
                href="javascript:void(0)"
                onClick={() => {
                  this.props.parentReference(
                    this.state.T_TELEFONO_MOVIL + "/" + this.state.T_PASSWORD
                  );
                }}
              >
                Accede a tu cuenta
              </a>
            </div>

            <br />
          </div>
        </center>
        <form
          method="post"
          action={this.state.currentFormURL}
          style={{ display: "none" }}
        >
          <input type="text" name="login" value={this.state.T_TELEFONO_MOVIL.replace(" ","").replace("(","").replace(")","").replace("-","").replace("-","")} />
          <input type="text" name="password" value={this.state.T_PASSWORD} />
          <input type="submit" value="Submit" ref={this.inputLoginDS} />
        </form>
      </Grommet>
    );
  }
}
export default FormRegister;
